//活动管理
export default [
  {
    path: "/activityManage",
    component: () => import("../pages/activity/activityManage.vue"),
    name: "activityManage",
    title: "活动管理",
    meta: {
      title: '活动管理',
    },
  },
  // {
  //   path: "/addActivityManage",
  //   component: () => import("../pages/activity/addActivityManage.vue"),
  //   name: "addActivityManage",
  //   title: "活动管理",
  //   meta: {
  //     title: '活动管理',
  //   },
  // },
  {
    path: "/setPrice",
    component: () => import("../pages/activity/setPrice.vue"),
    name: "setPrice",
    title: "设置售价",
    meta: {
      title: '设置售价',
    },
  },
  {
    path: "/activityClassifyManage",
    component: () => import("../pages/activity/activityClassifyManage.vue"),
    name: "activityClassifyManage",
    title: "活动分类管理",
    meta: {
      title: '活动分类管理',
    },
  },
  {
    path: "/activityorder",
    component: () => import("../pages/activity/activityOrder.vue"),
    name: "activityorder",
    title: "活动订单管理",
    meta: {
      title: '活动订单管理',
    },
  },
  {
    path: "/eventCheckIn",
    component: () => import("../pages/activity/eventCheckIn.vue"),
    name: "eventCheckIn",
    title: "活动签到",
    meta: {
      title: '活动签到',
    },
  },
  {
    path: "/strategyReco",
    component: () => import("../pages/activity/strategyReco.vue"),
    name: "strategyReco",
    title: "攻略推荐",
    meta: {
      title: '攻略推荐',
    },
  },
  {
    path: "/storeManage",
    component: () => import("../pages/activity/storeManage.vue"),
    name: "storeManage",
    title: "畅玩管理",
    meta: {
      title: '畅玩管理',
    },
  },
  // {
  //   path: '/storeOrder',
  //   component: () => import("../pages/activity/storeOrder.vue"),
  //   name: 'orderStore',
  //   title: "订单管理",
  //   meta: {
  //     title: "订单管理"
  //   }
  // },
  {
    path: "/userCard",
    component: () => import("../pages/activity/storeCardManage.vue"),
    name: "userCard",
    title: "畅玩核销",
    meta: {
      title: '畅玩核销',
    },
  },
  {
    path: "/storeClassifyManage",
    component: () => import("../pages/activity/storeClassifyManage.vue"),
    name: "storeClassifyManage",
    title: "畅玩分类",
    meta: {
      title: '畅玩分类',
    },
  },
  {
    path: "/satisfactionQuestionnaire",
    component: () => import("../pages/activity/satisfactionQuestionnaire.vue"),
    name: "satisfactionQuestionnaire",
    title: "满意度调查",
    meta: {
      title: '满意度调查',
    },
  },
  {
    path: "/activityAudit",
    component: () => import("../pages/activity/activityAudit.vue"),
    name: "activityAudit",
    title: "活动审核",
    meta: {
      title: '活动审核',
    },
  },
  {
    path: "/eContract",
    component: () => import("../pages/activity/eContract.vue"),
    name: "eContract",
    title: "电子合同",
    meta: {
      title: '电子合同',
    },
  },
  {
    path: "/activityAddr",
    component: () => import("../pages/activity/activityAddr.vue"),
    name: "activityAddr",
    title: "地址管理",
    meta: {
      title: '地址管理',
    },
  },
  {
    path: "/zoneOrder",
    component: () => import("../pages/activity/zoneOrder.vue"),
    name: "zoneOrder",
    title: "订单管理",
    meta: {
      title: '订单管理',
    },
  },
  {
    path: "/activityTop",
    component: () => import("../pages/activity/activityTop.vue"),
    name: "activityTop",
    title: "畅玩首页",
    meta: {
      title: '畅玩首页',
    },
  },
]
